<div class="nutrition-stat-card">
  <div class="stat-header">
    <cs-label tertiary>{{ LL.intake.planOverview.dailyAverageCalories() }}</cs-label>
    <cs-tooltip x-small iconType="help">
      {{ LL.intake.planOverview.dailyAverageTooltip() }}
      <help-link helpId="@help:nutrition.daily-average">
        {{ LL.common.buttons.learnMore() }}
      </help-link>
    </cs-tooltip>
  </div>
  <cs-label secondary>{{ dailyAvg }}</cs-label>
</div>

@if (isCyclingEnabled) {
  <div class="nutrition-stat-card">
    <div class="stat-header">
      <cs-label tertiary>{{ LL.intake.planOverview.cutMealCalories() }}</cs-label>
      <cs-tooltip x-small iconType="help">
        {{ LL.intake.planOverview.cutMealTooltip() }}
        <help-link helpId="@help:nutrition.cut-meal">
          {{ LL.common.buttons.learnMore() }}
        </help-link>
      </cs-tooltip>
    </div>
    <cs-label secondary>{{ cutMealCalories }}</cs-label>
  </div>
  <div class="nutrition-stat-card">
    <div class="stat-header">
      <cs-label tertiary>{{ LL.intake.planOverview.bulkMealCalories() }}</cs-label>
      <cs-tooltip x-small iconType="help">
        {{ LL.intake.planOverview.bulkMealTooltip() }}
        <help-link helpId="@help:nutrition.bulk-meal">
          {{ LL.common.buttons.learnMore() }}
        </help-link>
      </cs-tooltip>
    </div>
    <cs-label secondary>{{ bulkMealCalories }}</cs-label>
  </div>
} @else if (mealCalories) {
  <div class="nutrition-stat-card">
    <div class="stat-header">
      <cs-label tertiary>{{ LL.intake.planOverview.mealCalories() }}</cs-label>
      <cs-tooltip x-small iconType="help">
        {{ LL.intake.planOverview.mealCaloriesTooltip() }}
        <help-link helpId="@help:nutrition.meal-average">
          {{ LL.common.buttons.learnMore() }}
        </help-link>
      </cs-tooltip>
    </div>
    <cs-label secondary>{{ mealCalories }}</cs-label>
  </div>
}
